import {
	Button,
	Card,
	Col,
	Input,
	Menu,
	Modal,
	Row,
	Select,
	Table,
	Typography,
	Pagination,
	Tooltip,
	Dropdown,
	Popover,
	DatePicker,
	Form,
	Grid,
} from 'antd'
import React, { useEffect, useState, useRef, useLayoutEffect, useInsertionEffect } from 'react'
import { CheckCircleOutlined, FileDoneOutlined } from '@ant-design/icons'
import openNotificationWithIcon from 'src/components/Notification'
const { Paragraph, Text } = Typography
function validateEmail(email) {
	var re =
		/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	return re.test(String(email))
}
const validate = (emails = []) => {
	if (emails.length !== new Set(emails).size) return false
	return emails.every(validateEmail)
}
export default function ModalEmailSend({ open, onClose, confirm, loadingExport = false, email }) {
	const [form] = Form.useForm()

	useEffect(() => {
		form.setFieldsValue({ CustomerEmail: email })
	}, [email])

	return (
		<Modal
			title={<span style={{ fontSize: 20, color: '#181c32' }}>Gửi file đến email</span>}
			open={open}
			footer={false}
			onCancel={() => onClose()}
			width={800}
		>
			<div>
				<Form form={form} layout="vertical">
					<Form.Item
						label="Email"
						className="form-item-profile-infomation"
						name={'CustomerEmail'}
						rules={[
							{ required: true, message: 'Vui lòng nhập email' },
							() => ({
								validator(_, value) {
									if (!validate(value)) {
										return Promise.reject('Email không đúng định dạng')
									}
									if (value.join(';').length > 200) {
										return Promise.reject('Vui lòng không nhập quá 200 kí tự')
									}
									return Promise.resolve()
								},
							}),
						]}
					>
						<Select
							mode="tags"
							open={false}
							tokenSeparators={[';', ',', ' ']}
							style={{
								width: '100%',
								height: 80,
							}}
						/>
					</Form.Item>
				</Form>
				<div className="btn-submit-print">
					<Button
						className="btn-submit-print-cancel"
						onClick={() => onClose()}
						style={{ height: 40, fontSize: 16 }}
					>
						Hủy
					</Button>
					<Button
						type="primary"
						onClick={() => {
							form.validateFields().then((value) => {
								confirm(value)
							})
						}}
						style={{ height: 40, fontSize: 16 }}
						loading={loadingExport}
					>
						Gửi
					</Button>
				</div>
			</div>
		</Modal>
	)
}
